// For full API documentation, including code examples, visit http://wix.to/94BuAAs

let currentProduct 

$w.onReady(function () {

	$w("#productPage").getProduct().then((product) => {

		console.log(product)

		currentProduct = product
	})

	$w("#productPage").onViewportEnter((event) => {

		console.log(currentProduct)
		
		let buy = $w("pre p a")[0]

		if (buy != undefined) {
			buy.setAttribute( 'class', 'button' );
		}
	});

});

// http://www.books4u.co.il/cartlogic.asp?pid=199000604&q=1

export function button1_click(event) {

	//Add your code for this event here: 
}